module.exports = __webpack_public_path__ + "img/desktop.edc6b86a.png";